﻿import type { GetMQTTResponse } from '@/api/mqtt.api'

export type RealtimeSeries = {
  dataType: string
  /** Liczba wartości w CSV, czyli liczba indeksów. */
  count: number
  base?: number
  spread?: number
  /** Zaokrąglenie do liczby całkowitej, np. maski bitowe statusów. */
  int?: boolean
}

/** Parametry podglądu dla typowych nazw typów danych: baza i rozrzut serii.
 * Nie są danymi urządzenia ani kontraktem backendu — służą wyłącznie do tego,
 * żeby kontrolka postawiona na kanwie pokazała odczyt w sensownym rzędzie
 * wielkości, a nie zero. Typ danych spoza tej listy dostaje zakres wyliczony
 * z `minValue`/`maxValue` elementu. */
export const PREVIEW_SERIES_SEED: RealtimeSeries[] = [
  { dataType: 'status', count: 1, base: 21, spread: 20, int: true },
  { dataType: 'alarmbits', count: 1, base: 6, spread: 8, int: true },
  { dataType: 'load', count: 3, base: 8, spread: 4 },
  { dataType: 'resource', count: 1, base: 78, spread: 12 },
  { dataType: 'cycles', count: 1, base: 1250, spread: 180, int: true },
  { dataType: 'wind', count: 1, base: 7, spread: 5 },
  { dataType: 'temp', count: 4, base: 58, spread: 30 },
  { dataType: 'angle', count: 1, base: 42, spread: 30 },
  { dataType: 'speed', count: 2, base: 32, spread: 20 },
]

const STATIC_CREATED_AT = new Date('2999-12-31T00:00:00.000Z')

/** Statyczny, deterministyczny snapshot pomiarów dla podglądu na kanwie: bez
 * interwału i bez losowości, więc nic nie tyka ani nie miga. Wartości wynikają
 * z bazy serii, kolejne indeksy są lekko zróżnicowane dla czytelności. */
export const buildStaticSnapshot = (series: RealtimeSeries[]): GetMQTTResponse[] => {
  const data: GetMQTTResponse[] = series.map((s) => {
    const base = s.base ?? 50
    const values = Array.from({ length: Math.max(1, s.count) }, (_, i) => {
      const v = Math.max(0, base * (1 + i * 0.06))
      return s.int ? String(Math.round(v)) : (+v.toFixed(1)).toString()
    })
    return { type: s.dataType, value: values.join(','), createdAt: STATIC_CREATED_AT }
  })
  data.push({ type: 'alert', value: 'normal', createdAt: STATIC_CREATED_AT })
  return data
}
